import { render, staticRenderFns } from "./AgencyContestViewTemplate.vue?vue&type=template&id=c2bdb772&scoped=true&"
import script from "./AgencyContestViewTemplate.vue?vue&type=script&lang=js&"
export * from "./AgencyContestViewTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bdb772",
  null
  
)

export default component.exports